export default __webpack_public_path__ + "static/media/soniya.9bbb69bd.jpg";